module.exports = __webpack_public_path__ + "static/media/ELS80FL01.12738158.png";